import React, { useMemo } from 'react';

export default function MenuList({ items, onAdd }) {
  const grouped = useMemo(() => {
    const g = {};
    for (const it of items) {
      const c = it.category || 'Other';
      (g[c] = g[c] || []).push(it);
    }
    return g;
  }, [items]);

  if (!items.length) return <div className="empty">Loading menu…</div>;

  return (
    <div className="menu-list">
      {Object.entries(grouped).map(([cat, list]) => (
        <div key={cat} className="menu-cat">
          <h3>{cat}</h3>
          {list.map((it) => (
            <div key={it._id} className="menu-item">
              <div className="menu-emoji">{it.emoji || '🍽️'}</div>
              <div className="menu-info">
                <div className="menu-name">{it.name}</div>
                <div className="menu-desc">{it.description}</div>
              </div>
              <div className="menu-price">RM {it.price.toFixed(2)}</div>
              <button className="btn-add" onClick={() => onAdd(it)}>+</button>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
